<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"
        style="width: 310px;flex: auto;">{{ 'bikeshop.bike_sale.record_bike_sale' | translate }}</h4>
    <div class="wizard">
        <ul>
            <li>
                <a class="first">
          <span class="wizard-step" [ngClass]="{ active: step === 1, complete: step > 1 }">
            <span [ngClass]="{'inner-circle':step === 1}"></span>
            <span [ngClass]="{ hide: step > 1 }"></span>
          </span>
                    <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">{{
                        'bikeshop.bike_sale.customer_details' | translate
                        }}</span>
                </a>
            </li>
            <li>
                <a>
          <span class="wizard-step" [ngClass]="{ active: step === 2, complete: step > 2 }">
            <span [ngClass]="{'inner-circle':step === 2}"></span>
            <span [ngClass]="{ hide: step > 2 }"></span>
          </span>
                    <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">{{
                        'bikeshop.bike_sale.select_bike' | translate
                        }}</span>
                </a>
            </li>
        </ul>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <div *ngIf="step === 1">
        <div style="margin-top:8px;">
            <div>
                <app-cyclist [partnerId]="partnerId" [user]="selectedCyclist" (update)="newCyclist($event)"
                             [nextCyclist]="nextCyclist" [messageService]="messageService"
                             bikeSale="true"></app-cyclist>
            </div>
        </div>
    </div>

    <div *ngIf="step === 2">
        <div>
            <div *ngIf="allowEmployeeSelection">
                <div class="row margin-top-8">
                    <div class="col-md-2"></div>
                    <div class="col-md-2 label" [ngClass]="{'red': salesPersonID === null}">
                        *{{'bikeshop.bike_sale.select_sales_person' | translate}}:
                    </div>
                    <div class="col-md-4">
                        <div class="p-inputgroup">
                            <p-dropdown [options]="employees" [(ngModel)]="salesPersonID"
                                        placeholder="{{'bikeshop.bike_sale.select_sales_person' | translate}}">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="quote-table">

                <div class="row header">
                    <div class="col-md-2">
                        {{ "bikeshop.modal.update_job_card.quote.sku" | translate }}
                    </div>
                    <div class="col-md-3">
                        {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
                    </div>
                    <div class="col-md-2">
                        {{ "general.manufacturer" | translate }}
                    </div>
                    <div class="col-md-2">
                        {{ "general.model" | translate }}
                    </div>
                    <div class="col-md-1">
                        {{ "general.year" | translate }}
                    </div>
                    <div class="col-md-1 right" *ngIf="!VATInclusive">
                        {{ "bikeshop.modal.update_job_card.quote.unit_price" | translate }}
                    </div>
                    <div class="col-md-1 right" *ngIf="VATInclusive">
            <span>{{
                "bikeshop.modal.update_job_card.quote.price_incl_vat" | translate
                }}</span>
                    </div>
                    <div class="col-md-1 actions">
            <span pTooltip="{{
              'bikeshop.modal.update_job_card.quote.pos_sync_tooltip' | translate
            }}" tooltipPosition="bottom" class="hubtiger-sync"
                  style="font-size:20px;" [ngClass]="{ 'fa-spin': syncingPOS }"
                  (click)="syncPOS()"></span>
                    </div>
                </div>
                <div class="row quote-row" *ngFor="let bike of bikes;let i = index">
                    <div class="col-md-2">{{ bike.Sku }}</div>
                    <div class="col-md-3">{{ bike.Product.Name }}</div>
                    <div class="col-md-2">{{ bike.Manufacturer }}</div>
                    <div class="col-md-2">{{ bike.Model }}</div>
                    <div class="col-md-1">{{ bike.Year }}</div>
                    <div class="col-md-1 right" *ngIf="!VATInclusive"
                         style="padding-left:0px">{{ currencySymbol }}{{ bike.Product.UnitPrice | number: ".2-2"}}</div>
                    <div class="col-md-1 right" *ngIf="VATInclusive"
                         style="padding-left:0px">{{ currencySymbol }}{{ bike.Product.UnitPrice_IncludingTax | number: ".2-2" }}</div>
                    <div class="col-md-1 actions">
                        <span class="hubtiger-delete" (click)="deleteLineItem(i)"></span></div>
                </div>
                <div class="row header" style="padding-top: 0px" *ngIf="bikes.length > 0"></div>
                <div class="row margin-top-16" *ngIf="!showAddBikeForm">
                    <div class="col-md-9"></div>
                    <div class="col-md-3 right" *ngIf="!buttonDisabled">
                        <button pButton type="button" class="p-button-raised accent full-width"
                                (click)="showAddBikeForm = true"
                                label="{{ 'bikeshop.bike_sale.buttons.add_a_bike' | translate }}"></button>
                    </div>
                </div>

                <div class="add-bike-container" *ngIf="showAddBikeForm">
                    <form [formGroup]="bikeForm">
                        <div class="row">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label"
                                 [ngClass]="{'red': this.partnerData.POSSystemID > 0 && (!bikeForm.value.product || !bikeForm.value.product.SKU)}">
                                *{{ 'bikeshop.bike_sale.enter_sku_or_name' | translate }}:
                            </div>
                            <div class="col-md-4">
                                <div class="p-inputgroup">
                                    <p-autoComplete id="product" formControlName="product" field="SKU"
                                                    [suggestions]="searchResult"
                                                    [disabled]="partnerData.POSSystemID < 0" placeholder="{{
                'bikeshop.bike_sale.enter_sku_or_name' | translate
              }}" (completeMethod)="searchProducts($event)" (onSelect)="onSelect($event)">
                                        <ng-template let-product pTemplate="item">
                                            <div>
                                                <span>{{ product.SKU }} - {{ product.Name }}</span>
                                            </div>
                                        </ng-template>
                                    </p-autoComplete>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8" *ngIf="bikeForm.value.product && bikeForm.value.product.Name">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label">
                                {{ 'general.name' | translate }}:
                            </div>
                            <div class="col-md-4">
                                {{bikeForm.value.product.Name}}
                            </div>
                        </div>
                        <div class="row margin-top-8" *ngIf="bikeForm.value.product && bikeForm.value.product.Name">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label">
                                {{ (!VATInclusive ? "bikeshop.modal.update_job_card.quote.unit_price" : "bikeshop.modal.update_job_card.quote.price_incl_vat") | translate }}
                                :
                            </div>
                            <div class="col-md-4">
                                {{ currencySymbol }}{{ (!VATInclusive ? bikeForm.value.product.UnitPrice : bikeForm.value.product.UnitPrice_IncludingTax)| number: ".2-2"}}
                            </div>
                        </div>

                        <div class="row margin-top-8"
                             *ngIf="bikeForm.value.product && (bikeForm.value.product.Quantity !== undefined || bikeForm.value.product.Quantity !== null)">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label">
                                {{ 'general.quantity_in_stock' | translate }}:
                            </div>
                            <div class="col-md-4">
                                {{bikeForm.value.product.Quantity}}
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label" [ngClass]="{'red': !bikeForm.value.manufacturer}">
                                *{{ 'general.manufacturer' | translate }}:
                            </div>
                            <div class="col-md-4">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText formControlName="manufacturer"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-8">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label" [ngClass]="{'red': !bikeForm.value.model}">
                                *{{ 'general.model' | translate }}:
                            </div>
                            <div class="col-md-4">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText formControlName="model"/>
                                </div>
                            </div>
                        </div>

                        <div class="row margin-top-8">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label" [ngClass]="{'red': !bikeForm.value.modalYear}">
                                *{{ 'general.year' | translate }}:
                            </div>
                            <div class="col-md-4">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText formControlName="modalYear"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-8">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label" [ngClass]="{'red': !bikeForm.value.datePurchased}">
                                *{{ 'general.date_purchased' | translate }}:
                            </div>
                            <div class="col-md-4">
                                <div class="p-inputgroup">
                                    <p-calendar formControlName="datePurchased" dateFormat="dd/mm/yy"></p-calendar>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-8">
                            <div class="col-md-2"></div>
                            <div class="col-md-4 label" [ngClass]="{'red': !bikeForm.value.serialNumber}">
                                {{ 'bikeshop.modal.shared.bike.serial_no' | translate }}:
                            </div>
                            <div class="col-md-4">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText formControlName="serialNumber"/>
                                </div>
                            </div>
                        </div>
                        <div class="row margin-top-16">
                            <div class="col-md-3"></div>
                            <div class="col-md-3 right">
                                <button pButton type="button" class="p-button-raised alternate full-width"
                                        (click)="showAddBikeForm = false"
                                        label="{{ 'general.cancel' | translate }}"></button>
                            </div>
                            <div class="col-md-3 right">
                                <button pButton type="button" class="p-button-raised accent full-width"
                                        (click)="addBike()"
                                        label="{{ 'bikeshop.bike_sale.buttons.add' | translate }}"
                                        [disabled]="!bikeForm.valid"></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>
    </div>
</div>
<div class="modal-footer" *ngIf="!(cyclists && cyclists.length === 0 && step == 1)">
    <div class="row">
        <div class="col-md-3">
            <button *ngIf="step > 1" pButton type="button" class="p-button-raised full-width" (click)="back()"
                    label="{{ 'bikeshop.bike_sale.buttons.back' | translate }}"></button>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-3" *ngIf="step === 1">
            <!-- <button pButton type="button" class="p-button-raised full-width" (click)="next()"
              label="{{ 'bikeshop.bike_sale.buttons.next' | translate }}" [disabled]="!cyclists"></button> -->
        </div>
        <div class="col-md-3" *ngIf="step === 2">
            <div class="loading" *ngIf="loading">
                <div class="loader"></div>
            </div>
            <button *ngIf="!loading" pButton type="button" class="p-button-raised full-width" (click)="recordSale()"
                    label="{{ 'bikeshop.bike_sale.buttons.record_sale' | translate }}"
                    [disabled]="buttonDisabled || (!bikeForm.valid && showAddBikeForm ) || (!showAddBikeForm && bikes.length === 0) || (allowEmployeeSelection && salesPersonID === null)"></button>
        </div>
    </div>
    <div class="row" *ngIf="(bikeForm.valid || bikes.length) && allowEmployeeSelection && salesPersonID === null">
        <div class="col-md-12 sales-person-invalid">
            {{ 'bikeshop.bike_sale.sales_person_not_selected' | translate }}
        </div>
    </div>
</div>

<!-- [disabled]="buttonDisabled" -->
